
// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { isInactivePipeline } from '../applicant/helpers/status';

// utilities
import _, { get } from 'lodash';

// components
import RaisedButton from '../../common/components/c_RaisedButton';
import Logo from '../../common/svgs/Logo';
import ApplicantMenu from '../f_applicantMenu';
import Copyright from '../f_copyright';

// styling objects
const welcomeButtonStyle = { width: '296px', height: '45px' };

// redux action creators
import * as syncActionCreators from '../../redux/actionCreators/sync';
import * as asyncActionCreators from '../../redux/actionCreators/async';
import { logOut } from '../../redux/actionCreators/async/auth';

// view ordering array
import { viewOrderArr } from '../r_ApplicantDashboard/viewOrderArr';


@connect(state => ({
  firstName: state.user.firstName,
  nickName: state.user.nickName,
  profileId: state.user.profileId,
  userId: state.user.id,
  profile: state.profile,
  applicantProfile: state.applicantProfile,
  workExperience: state.workExperience,
  tempState: state.tempState,
  labels: get(state.labels, 'ApplicantLanding', {}),
  commonLabels: get(state.labels, 'Common', {}),
  qs: state.applicantProfile.qualifyingspecialist
}), ({
  push,
  logOut,
  getProfileById: asyncActionCreators.getProfileById,
  updateApplicant: syncActionCreators.updateApplicant,
  persistApplicantUpdate: asyncActionCreators.persistApplicantUpdate
}))
export default class ApplicantLanding extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired,
    getProfileById: PropTypes.func.isRequired,
    updateApplicant: PropTypes.func.isRequired,
    persistApplicantUpdate: PropTypes.func.isRequired,
    firstName: PropTypes.string.isRequired,
    profileId: PropTypes.number.isRequired,
    userId: PropTypes.number.isRequired,
    nickName: PropTypes.string,
    profile: PropTypes.object,
    applicantProfile: PropTypes.object.isRequired,
    workExperience: PropTypes.object,
    tempState: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    logOut: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    commonLabels: PropTypes.object,
    qs: PropTypes.object
  }

  constructor() {
    super();
    this.closeWelcome = :: this.closeWelcome;
    this.isInactive = :: this.isInactive;
    this.hasProgressedPassedPending = :: this.hasProgressedPassedPending;
    this.isPendingApplication = :: this.isPendingApplication;
    this.state = {
      welcomePage: {}
    };
  }

  componentWillMount() {

    try {

      /**
        * Check for an inactive status and direct to inactive route...
        */
      if (this.isInactive() && !this.props.location.pathname.includes('inactive')) {
        this.props.push('/applicant/inactive');
      }

      const welcomePage = this.refreshWelcome();

      this.setState({ welcomePage }, () => {

        if (_.isEmpty(welcomePage)) {
          this.closeWelcome();
          return null;
        }
      });

    } catch (err) {
      console.log(err);
    }

  }

  isInactive() {
    return isInactivePipeline(this.props.profile.applicantStatus);
  }

  isQSAssigned() {
    return !_.isEmpty(this.props.qs);
  }

  isPendingApplication() {
    return this.props.profile.applicantStatus === 3;
  }

  hasProgressedPassedPending() {
    return this.props.profile.applicantStatus >= 3;
  }

  hasValidViewStateToSet() {
    let r = false;
    if (this.props.hasOwnProperty('applicantProfile')) {
      if (this.props.applicantProfile.hasOwnProperty('viewState')) {
        r = true;
      }
    }
    return r;
  }


  updateWelcomeViewState() {

    if (this.hasProgressedPassedPending()) {
      if (this.hasValidViewStateToSet()) {
        // if component.saveFunc is provided then use that, otherwise use default route hitting actionCreator
        const newState = _.cloneDeep(this.props.tempState);
        _.set(newState, 'user.id', this.props.userId);
        _.set(newState, 'profile.id', this.props.profileId);

        const objPath = 'profile.viewState.progress.applicant.application.Welcome.done';
        _.set(newState, objPath, true);

        newState.profile.viewState = _.merge(
          {},
          this.props.applicantProfile.viewState,
          newState.profile.viewState
        );

        // update front end
        this.props.updateApplicant(newState);

        // update back end
        this.props.persistApplicantUpdate(newState);
      }
    }
  }

  refreshWelcome() {
    let messagesObj = this.props.labels.welcomeMessages.welcome;

    if (this.isInactive()) {
      // message depends on the qualifying specialist
      messagesObj = this.props.labels.welcomeMessages.welcomeInactive;
      if (this.isQSAssigned()) {
        messagesObj.message = this.props.labels.welcomeMessages.welcomeInactive.qsAssigned;
      } else {
        messagesObj.message = this.props.labels.welcomeMessages.welcomeInactive.noQsAssigned;
      }
      return messagesObj;

    } else if (this.isPendingApplication()) { // Only firstTime for "Pending Application" Status

      const profile = _.isEmpty(this.props.applicantProfile) ? this.props.profile : this.props.applicantProfile;
      const welcomePath = 'viewState.progress.applicant.application.Welcome.done';
      const submitPath = 'viewState.progress.applicant.application.Submit.done';

      const isWelcomeBack = _.get(profile, welcomePath, false) && !_.get(profile, submitPath, false);
      const isWelcome = !_.get(profile, welcomePath, false);

      if (isWelcomeBack) messagesObj = this.props.labels.welcomeMessages.welcomeBack;
      if (!isWelcome && !isWelcomeBack) messagesObj = {};

      return messagesObj;
    }

    return {};
  }

  static need = [
    (route, user) => asyncActionCreators.getProfileById(user.profileId)
  ]

  closeWelcome() {
    // set progress
    if (!this.props.viewState) {
      this.updateWelcomeViewState();
    }
    this.props.push(`/applicant/${viewOrderArr[0].key}${viewOrderArr[0].subNav ? `/${viewOrderArr[0].subNav[0].key}` : ''}`);
  }

  handleLogOut = () => {
    const { website } = this.props.commonLabels;

    this.props.logOut()
      .then(() => {
        window.location = website;
      })
      ;
  }

  render() {

    const viewName = this.props.nickName || this.props.firstName;
    this.refreshWelcome();
    const welcomePage = this.state.welcomePage;

    // bomb out until status can be determined
    if (!this.props.profile.applicantStatus) {
      return (<div className='application-landing clearfix'></div>);
    }

    return (
      <div className='application-landing clearfix'>
        <ApplicantMenu logOut={this.handleLogOut} />
        {
          _.isEmpty(this.state.welcomePage) ?
            null :
            <div className='center-container'>
              <Logo className='logo' />
              <div className='landing-welcome'>
                {welcomePage.title && `${welcomePage.title}, ${viewName}`}
              </div>
              <div className='landing-message' dangerouslySetInnerHTML={{__html: welcomePage.message}}>
              </div>
              {this.isInactive() && this.isQSAssigned() &&
                <div>
                  <div className='qs-content'>
                    <span className='qs-name'>{this.props.qs.firstName} {this.props.qs.lastName}</span>
                    <span className='qs-type'>Qualifying Specialist</span>
                  </div>
                  <div className='qs-info'>
                    <span style={{whiteSpace: 'nowrap'}}>{this.props.qs.email}</span>
                  </div>
                </div>
              }
              {!this.isInactive() &&
                <RaisedButton
                  label={'Start Now'}
                  data-id={'Start Now'}
                  style={welcomeButtonStyle}
                  onClick={this.closeWelcome}
                />
              }
            </div>
        }
        <Copyright />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantLanding/index.js